<div style=" padding: 20px" class="delete_container text-center fc_DEDEDE">
  <h4>Are you sure to delete this property?</h4>
  <div style="margin-top: 20px; display: flex; justify-content: space-between">
    <button mat-button (click)="close()" class="cancel_button">Cancel</button>
    <button mat-button (click)="delete()" class="delete_button">Delete</button>
  </div>
</div>